import React from 'react';
import { Box, Button, Flex, Text } from 'src/components/ui';

interface AddLocationCardProps {
	type: 'location' | 'service-area';
	label?: string;
	onClick: () => void;
	height?: string;
	maxWidth?: string;
}

const AddLocationCard: React.FC<AddLocationCardProps> = ({
	type,
	label,
	onClick,
	height = '300px',
	maxWidth = '500px',
}) => {
	const defaultLabel =
		type === 'location' ? 'Add Location' : 'Add Service Area';
	const displayLabel = label || defaultLabel;

	return (
		<Box
			position="relative"
			borderRadius="xl"
			overflow="hidden"
			h={height}
			maxW={maxWidth}
			bg="blackAlpha.400"
			boxShadow="lg"
			border="1px solid"
			borderColor="blackAlpha.500"
			cursor="pointer"
			onClick={onClick}
			transition="all 0.2s ease-in-out"
			_hover={{
				bg: 'blackAlpha.300',
			}}
		>
			<Box
				position="absolute"
				inset="0"
				zIndex={1}
				display="flex"
				flexDirection="column"
				justifyContent="center"
				alignItems="center"
				p={6}
			>
				<Box
					w="60px"
					h="60px"
					borderRadius="full"
					bg="lightgray"
					border="2px solid"
					borderColor="blackAlpha.300"
					display="flex"
					alignItems="center"
					justifyContent="center"
					mb={4}
					transition="all 0.2s ease-in-out"
					_groupHover={{
						bg: 'blackAlpha.200',
						borderColor: 'blackAlpha.400',
					}}
				>
					<Text fontSize="32px" fontWeight="bold" color="blackAlpha.600">
						+
					</Text>
				</Box>

				<Text
					fontSize="xl"
					fontWeight="semibold"
					color="blackAlpha.700"
					textAlign="center"
				>
					{displayLabel}
				</Text>
			</Box>
		</Box>
	);
};

export default AddLocationCard;
